module.exports = __webpack_public_path__ + "static/media/img4.3f3ed693.jpg";